var _rect, _line, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopTakeBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.6875,
    y: 2.79883,
    width: 18.5039,
    height: 18.5039,
    rx: 2.5,
    stroke: "#333333"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.82031,
    y1: 5.90234,
    x2: 20.8838,
    y2: 5.90234,
    stroke: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6001 10.0586C15.9531 10.0587 16.239 10.3455 16.239 10.6985C16.2388 11.0514 15.9529 11.3374 15.6001 11.3375H8.40453C8.05177 11.3372 7.76585 11.0513 7.76562 10.6985C7.76562 10.3456 8.05164 10.0588 8.40453 10.0586H15.6001Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3453 12.748C18.6983 12.7481 18.9842 13.035 18.9842 13.388C18.984 13.7408 18.6982 14.0268 18.3453 14.0269H5.67016C5.3174 14.0267 5.03147 13.7408 5.03125 13.388C5.03125 13.035 5.31726 12.7483 5.67016 12.748H18.3453Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6001 15.4375C15.9531 15.4376 16.239 15.7244 16.239 16.0774C16.2388 16.4303 15.9529 16.7163 15.6001 16.7164H8.40453C8.05177 16.7161 7.76585 16.4302 7.76562 16.0774C7.76562 15.7245 8.05164 15.4377 8.40453 15.4375H15.6001Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopTakeBag);
export default __webpack_public_path__ + "static/media/shop-take-bag.646a31cd8495078c1f354e75533738c4.svg";
export { ForwardRef as ReactComponent };